import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GamePopularList = paths['/v4/game/popular/'];

const getGamePopularList = createRequest<GamePopularList>('/pc/v4/game/popular/');

export default getGamePopularList;
